import { useNavigate } from '@tanstack/react-router';

import { useAppShortcut } from '@/features/shortcuts';
import { terminalClaimsTabKey } from '@/features/sprites/local-terminal-keys';
import { Routes } from '@/types/routes';
import { AppCapability, isCapable } from '@/utils/capabilities';

export function useRegisterNewChatHotkey() {
  const navigate = useNavigate();

  useAppShortcut(
    'app.newChat',
    () => {
      if (!isCapable(AppCapability.HotKeys)) return;
      navigate({
        to: Routes.Chats as string,
        search: { new: true },
      });
    },
    {
      preventDefault: true,
      enableOnContentEditable: true,
      enableOnFormTags: true,
      // In the local terminal dock cmd+n opens a terminal tab, not a chat.
      // Exactly one side acts per press; the dock decides (local-terminal-keys.ts).
      ignoreEventWhen: terminalClaimsTabKey,
    }
  );
}
